import React from "react";
import RectangleImg from "../../assets/icons/machine-rectangle.png";

const LogItemImage = () => {
  return (
    <div>
      <img
        src={RectangleImg}
        alt="rectangle"
        className="w-auto h-[68px] lg:h-[70px] xl:h-[84px] 2xl:h-[95px]"
      />
    </div>
  );
};

export default LogItemImage;
